/**
 * Merchant entity used across the application.
 * Same structure returned by:
 * - Login API: member_details.merchants
 * - Merchant API: GET /v2/user-merchants/user/merchants
 */
export interface Merchant {
  id: string; // UserMerchant junction ID (UUID)
  merchant_id: string; // Actual merchant ID (char14) - USED IN X-Merchant-ID HEADER
  merchant_name: string; // Display name
  merchant_country: string; // Country
  merchant_status: 'active' | 'inactive';
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

/**
 * Filter merchants to only return active ones.
 * Used for both login response and merchant API response.
 */
export function filterActiveMerchants(
  merchants: Merchant[] | undefined | null,
): Merchant[] {
  if (!Array.isArray(merchants) || merchants.length === 0) {
    return [];
  }
  return merchants.filter(
    (m) => String(m.merchant_status || '').toLowerCase() === 'active',
  );
}

/** Direct array response from GET /v2/user-merchants/user/merchants */
export type GetUserMerchantsResponse = Merchant[];
